import React from "react";
import { Icon } from "antd";
const DeleteButton = ({ onClick }) => (
    <div onClick={onClick} className="delete-button-container">
        <Icon type="delete" />
    </div>
)
export default DeleteButton;